
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IWbuBackButtonProps,
  IWbuBackButtonMapperProps,
  IWbuBackButtonControllerProps,
  IWbuBackButtonStateValues,
} from '../../../components/WbuBackButton/WbuBackButton.props';

export default withCompController<
  IWbuBackButtonMapperProps,
  IWbuBackButtonControllerProps,
  IWbuBackButtonProps,
  IWbuBackButtonStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
